import { faMobile } from "@fortawesome/pro-regular-svg-icons/faMobile";
import { faPhone } from "@fortawesome/pro-regular-svg-icons/faPhone";
import { faPhoneOffice } from "@fortawesome/pro-regular-svg-icons/faPhoneOffice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from '@mui/material';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import { UserPhoneType } from 'models/ApiEnums';
import { UserPhoneModel } from 'models/ApiModels';
import * as React from 'react';
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    phones: UserPhoneModel[];
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const UserPhones: React.FC<IProps> = (props) => {
    const { phones } = props;
    const { t } = useTranslation();

    if (!phones)
        return null;

    return (
        <Grid container spacing={1}>
            {
                phones.map((v, index) => {
                    return (
                        <Grid item key={index}>
                            <MuiColor variant="muted">
                                <small>
                                    <span
                                        title={
                                        v.type == UserPhoneType.Mobile
                                            ? "Celular"
                                            : v.type == UserPhoneType.Comercial
                                                ? "Comercial"
                                                : "Residencial"
                                        }
                                    >
                                        <FontAwesomeIcon
                                            icon={
                                                v.type == UserPhoneType.Mobile
                                                    ? faMobile
                                                    : v.type == UserPhoneType.Comercial
                                                        ? faPhoneOffice
                                                        : faPhone
                                            }

                                        title={
                                            v.type == UserPhoneType.Mobile
                                                ? t("Common.UserPhoneType.Mobile")
                                                : v.type == UserPhoneType.Comercial
                                                    ? t("Common.UserPhoneType.Comercial")
                                                    : t("Common.UserPhoneType.Residential")
                                        }
                                        
                                            fixedWidth
                                        />
                                        &nbsp;
                                        {v.number}
                                    </span>
                                </small>
                            </MuiColor>
                        </Grid>
                    )
                })
            }
        </Grid>
    );
}

export default UserPhones